(function () {
  'use strict';

  var GRID_SELECTOR = [
    '.ak-top-collection-desktop__grid',
    '.ak-vpcompress22-desktop__grid',
    '.ak-longcenter-v2-desktop__grid',
    '.ak-normal-divider-desktop__grid',
    '.ak-theend-v2-desktop__grid'
  ].join(',');

  var DIVIDER_SELECTOR = [
    '.ak-longcenter-short-desktop__grid',
    GRID_SELECTOR
  ].join(',');

  var resizeFrame = null;
  var gridObserver = null;
  var initialSyncComplete = false;
  var lastViewportWidth = 0;
  var lastViewportHeight = 0;
  var lastPixelRatio = 0;

  /* The frame owns exactly one top slot. Brand is the default variant;
     a single-level menu replaces its contents without creating a second
     active top layer. Keeping this decision global prevents page-specific
     sticky systems from competing for the same viewport edge. */
  function syncFrameTopOwner() {
    var html = document.documentElement;
    var singleLevelTop = document.querySelector(
      '[data-ak-frame-top="single-level"]'
    );
    var brandTops = document.querySelectorAll(
      '[data-ak-frame-top="brand"]'
    );
    var mode = singleLevelTop
      ? 'single-level'
      : brandTops.length
        ? 'brand'
        : 'none';

    html.setAttribute('data-ak-frame-top-mode', mode);

    brandTops.forEach(function (brandTop) {
      brandTop.hidden = Boolean(singleLevelTop);
      brandTop.setAttribute(
        'aria-hidden',
        singleLevelTop ? 'true' : 'false'
      );
    });
  }

  function isActive() {
    return (
      window.innerWidth > 1200 &&
      document.body &&
      (document.body.classList.contains('ak-page-index') || document.body.classList.contains('ak-papers-editorial-page') || document.querySelector('#filterable.collection, [data-ak-main-search]')) &&
      document.body.classList.contains('ak-site-frame-enabled')
    );
  }

  function snap(value) {
    return window.AKPixels.snap(value);
  }

  function subdivisionsPerField() {
    return window.innerWidth < 1800 ? 12 : 15;
  }

  function rowsPerDivider() {
    return window.innerWidth < 1800 ? 2 : 3;
  }

  function syncAttachedCarouselShell(grid, height) {
    var shell = grid.closest('.ak-home-first-carousel-top-grid');

    if (!shell) {
      return;
    }

    var value = height + 'px';
    var host = shell.parentElement;

    shell.style.setProperty(
      '--ak-home-first-carousel-grid-height',
      value
    );

    if (!host) {
      return;
    }

    host.style.setProperty(
      '--ak-home-first-carousel-grid-height',
      value
    );
    host.style.setProperty(
      'margin-top',
      '-' + value,
      'important'
    );
  }

  function syncDividerHeight(grid, preparedHeight) {
    if (!grid || !isActive()) {
      return;
    }

    /* Row count and box height are one state. Never derive the compact
       height from the current grid width: doing so lets the third rule
       appear before the shell has grown when a live resize crosses 1800px.
       Round the total span once; individual row boundaries use that span. */
    var height = preparedHeight;
    if (height === undefined) {
      var railHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--ak-site-rail')) || 44;
      height = snap(railHeight * rowsPerDivider() / 3);
    }

    var value = height + 'px';
    if (grid.style.getPropertyValue('height') !== value) grid.style.setProperty('height', value, 'important');
    if (document.body.style.getPropertyValue('--ak-wide-divider-height') !== value) {
      document.body.style.setProperty('--ak-wide-divider-height', value);
    }
    syncAttachedCarouselShell(grid, height);
  }

  function syncVerticalLineCount(layer) {
    var desired = subdivisionsPerField() * 6;
    var lines = Array.prototype.slice.call(
      layer.querySelectorAll('.ak-shared-six-grid-line--vertical')
    );

    if (lines.length > desired) {
      lines.slice(desired).forEach(function (line) {
        line.remove();
      });
      lines.length = desired;
    }

    if (lines.length < desired) {
      var fragment = document.createDocumentFragment();

      for (var column = lines.length; column < desired; column += 1) {
        var vertical = document.createElement('i');
        vertical.className = 'ak-shared-six-grid-line--vertical';
        vertical.dataset.akSharedSixGridLine = String(column);
        fragment.appendChild(vertical);
      }

      layer.appendChild(fragment);
    }
  }

  function syncGrid(grid, preparedRect) {
    if (!grid || !isActive()) {
      return;
    }

    if (!preparedRect) syncDividerHeight(grid);
    var rect = preparedRect || grid.getBoundingClientRect();
    var documentTop = rect.top + window.scrollY;
    var geometryKey = [rect.left, documentTop, rect.width, rect.height, window.devicePixelRatio || 1, subdivisionsPerField(), rowsPerDivider()].join(':');
    if (grid._akSharedGeometryKey === geometryKey) return;
    grid._akSharedGeometryKey = geometryKey;
    if (!rect.width || !rect.height) {
      return;
    }

    grid
      .querySelectorAll('.ak-shared-six-grid-line--vertical')
      .forEach(function (line) {
        var index = Number(line.dataset.akSharedSixGridLine);
        var subdivisions = subdivisionsPerField();
        var total = subdivisions * 6;

        if (index >= total) {
          line.style.display = 'none';
          return;
        }

        line.style.display = 'block';

        var fieldIndex =
          index === total ? 5 : Math.floor(index / subdivisions);
        var subdivision =
          index === total ? subdivisions : index % subdivisions;
        var fieldWidth = rect.width / 6;
        var absoluteX =
          rect.left +
          fieldWidth * fieldIndex +
          fieldWidth * subdivision / subdivisions;

        /* The final 1px rule belongs inside the grid. At 100% it would be
           painted outside the box while the horizontal rule stops inside,
           leaving a white top-right corner pixel. */
        /* Master boundaries are shared with carousel/header percentages and
           must not be rounded by an element-local calculation. */
        var isMasterBoundary = subdivision === 0;
        var localX = isMasterBoundary
          ? fieldWidth * fieldIndex
          : snap(absoluteX) - rect.left;

        line.style.left = localX + 'px';
        /* Vertical and horizontal rules overlap on the same physical pixel.
           Starting one pixel lower leaves a visible hole at every junction
           in Safari and at some fractional Chrome widths. */
        line.style.setProperty('top', '0px', 'important');
      });

    grid
      .querySelectorAll('.ak-shared-six-grid-line--horizontal')
      .forEach(function (line) {
        var index = Number(line.dataset.akSharedSixGridRow);
        var rows = rowsPerDivider();
        var visibleIndex = index;

        /* On laptop desktop we keep the two rows nearest the following
           content. Row one is the row that disappears; never row three. */
        if (rows === 2) {
          if (index === 0) {
            line.style.display = 'none';
            return;
          }

          visibleIndex = index - 1;
        }

        if (visibleIndex >= rows) {
          line.style.display = 'none';
          return;
        }

        line.style.display = 'block';

        var closesAtBottom = grid.matches(
          '.ak-vpcompress22-desktop__grid, ' +
          '.ak-theend-v2-desktop__grid--top'
        );
        var row = closesAtBottom
          ? visibleIndex + 1
          : visibleIndex;

        // Round absolute document coordinates, not viewport coordinates or
        // repeated row sizes. This keeps the same physical lattice after a
        // restored scroll position, and prevents cumulative rounding drift.
        var localY = window.AKPixels.local(
          documentTop, rect.height * row / rows - (closesAtBottom ? 1 : 0)
        );

        line.style.top = localY + 'px';
      });
  }

  function ensureGrid(grid, deferSync) {
    if (!grid) {
      return;
    }

    var layer = grid.querySelector(':scope > .ak-shared-six-grid-lines');

    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'ak-shared-six-grid-lines';
      layer.setAttribute('aria-hidden', 'true');

      var fragment = document.createDocumentFragment();
      var totalColumns = subdivisionsPerField() * 6;

      for (var column = 0; column < totalColumns; column += 1) {
        var vertical = document.createElement('i');
        vertical.className = 'ak-shared-six-grid-line--vertical';
        vertical.dataset.akSharedSixGridLine = String(column);
        fragment.appendChild(vertical);
      }

      for (var row = 0; row < 3; row += 1) {
        var horizontal = document.createElement('i');
        horizontal.className = 'ak-shared-six-grid-line--horizontal';
        horizontal.dataset.akSharedSixGridRow = String(row);
        fragment.appendChild(horizontal);
      }

      layer.appendChild(fragment);
      grid.appendChild(layer);
    }

    syncVerticalLineCount(layer);

    if (
      window.ResizeObserver &&
      grid.dataset.akSharedSixGridObserved !== 'true'
    ) {
      grid.dataset.akSharedSixGridObserved = 'true';

      var observer = new ResizeObserver(function () {
        syncGrid(grid);
      });

      observer.observe(grid);
    }

    if (!deferSync) syncGrid(grid);
  }

  function syncAll(forceLegacyLineSync) {
    syncFrameTopOwner();

    if (!isActive()) {
      return;
    }

    var prepareUnderLoader = window.AK_BOOT && !window.AK_BOOT.revealed;
    if (prepareUnderLoader) window.AK_BOOT.register('construction');
    var railHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--ak-site-rail')) || 44;
    var preparedHeight = snap(railHeight * rowsPerDivider() / 3);
    document.querySelectorAll(DIVIDER_SELECTOR).forEach(function (grid) { syncDividerHeight(grid, preparedHeight); });
    var preparedGrids = [];

    document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
      if (prepareUnderLoader || grid.querySelector(':scope > .ak-shared-six-grid-lines')) {
        ensureGrid(grid, true);
        preparedGrids.push(grid);
      } else {
        observeGrid(grid);
      }
    });

    // Build all layers, then read all boxes, then paint all line positions.
    // Interleaving one layout flush per divider blocked the main thread.
    var gridMeasurements = preparedGrids.map(function (grid) { return {grid: grid, rect: grid.getBoundingClientRect()}; });
    gridMeasurements.forEach(function (entry) { syncGrid(entry.grid, entry.rect); });

    /* The first carousel's grid is reparented into a shell whose height is
       updated above. Its own legacy resize listener can run before this
       file and therefore calculate rows against the old shell. Re-run its
       line layout now, after the new 2/3-row height is committed. */
    if (
      forceLegacyLineSync &&
      typeof window.akSyncLongcenterShortDesktopLines === 'function'
    ) {
      window.akSyncLongcenterShortDesktopLines();
    }

    initialSyncComplete = true;
    lastViewportWidth = window.innerWidth;
    lastViewportHeight = window.innerHeight;
    lastPixelRatio = window.devicePixelRatio || 1;
    if (prepareUnderLoader) {
      var grids = Array.from(document.querySelectorAll(GRID_SELECTOR));
      window.AK_BOOT.constructionReadiness = {
        total: grids.length,
        ready: grids.filter(function (grid) { return !!grid.querySelector(':scope > .ak-shared-six-grid-lines'); }).length,
        finished: performance.now()
      };
      window.AK_BOOT.markReady('construction');
    }
  }

  function observeGrid(grid) {
    if (!grid || grid.dataset.akSharedSixGridQueued === 'true') {
      return;
    }

    grid.dataset.akSharedSixGridQueued = 'true';

    if (!window.IntersectionObserver) {
      ensureGrid(grid);
      return;
    }

    if (!gridObserver) {
      gridObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            ensureGrid(entry.target);
            gridObserver.unobserve(entry.target);
          });
        },
        {
          rootMargin: '1200px 0px',
          threshold: 0
        }
      );
    }

    gridObserver.observe(grid);
  }

  function queueSync() {
    if (
      initialSyncComplete &&
      lastViewportWidth === window.innerWidth &&
      lastViewportHeight === window.innerHeight &&
      lastPixelRatio === (window.devicePixelRatio || 1)
    ) {
      return;
    }

    if (resizeFrame !== null) {
      cancelAnimationFrame(resizeFrame);
    }

    resizeFrame = requestAnimationFrame(function () {
      resizeFrame = null;
      syncAll(true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll(false);
    });
  } else {
    syncAll(false);
  }

  /* DOMContentLoaded already establishes the complete desktop frame. A
     second full synchronous pass at window.load used to coincide with the
     intro line animation and cost an entire frame on both browsers. */
  window.addEventListener('resize', queueSync);
  window.addEventListener('ak:pixel-ratio-change', queueSync);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      queueSync();
    }
  });
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:unload', syncAll);
}());
